// import { AuthenticationResult, LogLevel } from "@azure/msal-browser";
import { AuthenticationResult, LogLevel } from "@azure/msal-browser";
import { clientId, urlLogin } from "../../services/http-common";

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: urlLogin,
    //navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "localStorage", 
    storeAuthStateInCookie: true, 
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */

// const silentRequest = {
//   scopes: ["openid", "profile"],
//   loginHint: "example@domain.net"
// };

// exporting config object for jest
if (typeof exports !== "undefined") {
  module.exports = {
    msalConfig: msalConfig,
    loginRequest: loginRequest,
  };
}

export interface IdTokenClaims {
  aud?: string; // Audience
  exp?: number; // Expiration time
  iss?: string; // Issuer
  sub?: string; // Subject
  iat?: number; // Issued at
  nbf?: number; // Not before
  preferred_username?: string; // Often used for username
  [key: string]: any; // Allow for additional claims
}

// Extend the AuthenticationResult type
export interface ExtendedAuthenticationResult extends AuthenticationResult {
  idTokenClaims: IdTokenClaims;
}